import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/User Interface/sp-menu";
import * as React from 'react';
export default {
  Content,
  React
};